// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__yE+Wt","content":"styles_content__99cKJ","header":"styles_header__jcFN3","body":"styles_body__KGjx7"};